// extracted by mini-css-extract-plugin
export default {"logo-container":"BrandLogo_logo-container__nVpN3","brand-logo":"BrandLogo_brand-logo__wAJpq"};